import { SEO } from "@/lib/seo";
import { Hero } from "@/components/home/Hero";
import { LiveNowSection } from "@/components/home/LiveNowSection";
import { Marquee } from "@/components/common/Marquee";
import { Manifesto } from "@/components/home/Manifesto";
import { MatchdayPreview } from "@/components/home/MatchdayPreview";
import { ContentPreview } from "@/components/home/ContentPreview";
import { CTASection } from "@/components/home/CTASection";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="Women's Grassroots Football Commentary & Live Coverage"
        description="WomensMatchDayLive delivers live commentary, live streams and matchday coverage of grassroots women's football across the UK."
        path="/"
      />
      <Hero />
      <LiveNowSection />
      <Marquee text={["WomensMatchDayLive", "Grassroots Football", "Live Commentary", "Women's Football Coverage"]} />
      <Manifesto />
      <MatchdayPreview />
      <ContentPreview />
      <CTASection />
    </div>
  );
}
